var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import uuid from 'uuid';
// - Get file Extension
var getExtension = function (fileName) {
    var re = /(?:\.([^.]+))?$/;
    return re.exec(fileName)[1];
};
// Converts image to canvas returns new canvas element
var convertImageToCanvas = function (image) {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext('2d').drawImage(image, 0, 0);
    return canvas;
};
/**
 * Constraint image size
 * @param {file} file
 * @param {number} maxWidth
 * @param {number} maxHeight
 */
var constraintImage = function (file, fileName, maxWidth, maxHeight) {
    console.warn(2);
    // Ensure it's an image
    if (file.type.match(/image.*/)) {
        // Load the image
        var reader = new FileReader();
        reader.onload = function (readerEvent) {
            var image = new Image();
            image.onload = function (imageEvent) {
                // Resize the image
                var canvas = document.createElement('canvas');
                var maxSize = 1400; // TODO : pull max size from a site config
                var width = image.width;
                var height = image.height;
                if (width > height) {
                    if (width > maxSize) {
                        height *= maxSize / width;
                        width = maxSize;
                    }
                }
                else {
                    if (height > maxSize) {
                        width *= maxSize / height;
                        height = maxSize;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                var dataUrl = canvas.toDataURL();
                var resizedImage = dataURLToBlob(dataUrl);
                var evt = new CustomEvent('onSendResizedImage', { detail: { resizedImage: resizedImage, fileName: fileName } });
                window.dispatchEvent(evt);
            };
            image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
    }
};
var constraintImage1 = function (arr, resizedArr, file, fileName, maxWidth, maxHeight) {
    console.warn(2);
    // Ensure it's an image
    for (var i = 0; i < arr.length; i++) { }
    arr.forEach(function (file) { return __awaiter(_this, void 0, void 0, function () {
        var reader;
        return __generator(this, function (_a) {
            if (file.type.match(/image.*/)) {
                reader = new FileReader();
                reader.onload = function (readerEvent) {
                    var image = new Image();
                    image.onload = function (imageEvent) {
                        // Resize the image
                        var canvas = document.createElement('canvas');
                        var maxSize = 750; // TODO : pull max size from a site config
                        var width = image.width;
                        var height = image.height;
                        if (width > height) {
                            if (width > maxSize) {
                                height *= maxSize / width;
                                width = maxSize;
                            }
                        }
                        else {
                            if (height > maxSize) {
                                width *= maxSize / height;
                                height = maxSize;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                        var dataUrl = canvas.toDataURL();
                        var resizedImage = dataURLToBlob(dataUrl);
                        var extension = getExtension(file.name);
                        var fileName = (uuid() + "." + extension);
                        file = { resizedImage: resizedImage, fileName: fileName };
                        var str = { resizedImage: resizedImage, fileName: fileName };
                        resizedArr.push(str);
                        var evt = new CustomEvent('onSendResizedImage', { detail: { resizedImage: resizedImage, fileName: fileName } });
                        window.dispatchEvent(evt);
                        if (resizedArr.length === arr.length) {
                            var evt_1 = new CustomEvent('onSendResizedImageArr', { detail: { resizedArr: resizedArr } });
                            window.dispatchEvent(evt_1);
                        }
                        // let evt = new CustomEvent('onSendResizedImageArr', { detail: { str } })
                        // window.dispatchEvent(evt)
                    };
                    image.src = readerEvent.target.result;
                };
                reader.readAsDataURL(file);
            }
            return [2 /*return*/];
        });
    }); });
    // if (resizedArr.length === arr.length) {
    // let evt = new CustomEvent('onSendResizedImageArr', { detail: { resizedArr } })
    // window.dispatchEvent(evt)
    // }
};
var img3Load = function (file, fileName, maxWidth, maxHeight) {
    // TODO : ADD CHECK TO ITS ENSURE GLB FILE
    if (file.name.match(/\.(gltf|glb)$/)) {
        var thisfile = (file);
        var evt = new CustomEvent('3dImgUpload', { detail: { thisfile: thisfile, fileName: fileName } });
        window.dispatchEvent(evt);
        //  
    }
};
/**
 * Convert data URL to blob
 * @param {object} dataURL
 */
var dataURLToBlob = function (dataURL) {
    var BASE64_MARKER = 'base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        var parts_1 = dataURL.split(',');
        var contentType_1 = parts_1[0].split(':')[1];
        var raw_1 = parts_1[1];
        return new Blob([raw_1], { type: contentType_1 });
    }
    var parts = dataURL.split(BASE64_MARKER);
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);
    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
};
export default {
    dataURLToBlob: dataURLToBlob,
    convertImageToCanvas: convertImageToCanvas,
    getExtension: getExtension,
    constraintImage: constraintImage,
    constraintImage1: constraintImage1,
    img3Load: img3Load
};



//////////////////
// WEBPACK FOOTER
// ./src/api/FileAPI.ts
// module id = 1271
// module chunks = 0 1 2 3 4 5 6 7